<div class="m-scrollable-teaser m-scrollable-teaser--products" data-t-name="ScrollableTeaser" #productScroller>
	<div class="m-scrollable-teaser__body">
		<div class="m-scrollable-teaser__scroll-wrapper js-m-scrollable-teaser__scroll-wrapper">
			<div *ngIf="introTitle || introDescription || introButton"
				class="m-scrollable-teaser__head js-m-scrollable-teaser__head">

				<cov-heading *ngIf="introTitle" [level]="introTitle.level" [modifier]="introTitle.modifier"
					[text]="introTitle.text" [class]="introTitle.class"></cov-heading>
				<p *ngIf="introDescription" class="m-scrollable-teaser__desc" [innerHTML]="introDescription"></p>
				<cov-button *ngIf="introButton" [buttonlink]="introButton.buttonlink" [text]="introButton.text"
					[href]="introButton.href" [modifier]="introButton.modifier" [class]="introButton.class">
				</cov-button>

			</div>
			<div class="m-scrollable-teaser__content js-m-scrollable-teaser__content">
				<div class="m-scrollable-teaser__slider-left state-m-scrollable-teaser__slider-arrow-hidden">
					<a class="m-scrollable-teaser__left-control js-m-scrollable-teaser__left-control"
						(click)="onLeftClick($event)"></a>
				</div>
				<div class="m-scrollable-teaser__slider-right">
					<a class="m-scrollable-teaser__right-control js-m-scrollable-teaser__right-control"
						(click)="onRightClick($event)"></a>
				</div>
				<div class="m-scrollable-teaser__content-scroll js-m-scrollable-teaser__content-scroll">
					<ul class="m-scrollable-teaser__list js-m-scrollable-teaser__list">
						<ng-container *ngFor="let result of searchResult">
							<li class="m-scrollable-teaser__list-item js-m-scrollable-teaser__list-item">
								<div class="m-scrollable-teaser-item">
									<div class="m-scrollable-teaser-item__text-area">
										<cov-heading [level]="result.title.level" [modifier]="result.title.modifier"
											[text]="result.title.text">
										</cov-heading>
										<p class="m-scrollable-teaser-item__description"
											[innerHTML]="result.description"></p>
										<cov-link [class]="result.link.class" [text]="ReadMoreLabel"
											[href]="result.link.href"></cov-link>
									</div>

								</div>
							</li>
						</ng-container>

						<li *ngIf="outroTitle || outroDescription || outroButton"
							class="m-scrollable-teaser__list-item">
							<div class="m-scrollable-teaser-item m-scrollable-teaser-item--explore">
								<div class="m-scrollable-teaser-item__text-area">
									<cov-heading *ngIf="outroTitle" [level]="outroTitle.level"
										[modifier]="outroTitle.modifier" [text]="outroTitle.text"
										[class]="outroTitle.class">
									</cov-heading>
									<p *ngIf="outroDescription" class="m-scrollable-teaser__desc"
										[innerHTML]="outroDescription"></p>
									<cov-button *ngIf="outroButton" [buttonlink]="outroButton.buttonlink"
										[text]="outroButton.text" [href]="outroButton.href"
										[modifier]="outroButton.modifier" [class]="outroButton.class"></cov-button>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

</div>